var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"return-to-plan-list c-btn c-btn--gray c-btn--gray--large",attrs:{"to":"/mypage/paid-membership/plans"}},[_vm._v("\n  契約済みプラン一覧に戻る\n")])}
var staticRenderFns = []

export { render, staticRenderFns }